export default __webpack_public_path__ + "static/media/img3.27b25e27.jpeg";